module.exports = __webpack_public_path__ + "img/sand-rock-big-08.b3f1015c.png";